import React, { useEffect } from "react";
import { useState } from "react";
import "../dashboard.css";
import config from "../../../../../helper/config.js";
import { customerConstants } from "../../../../../helper/constants.js";
import PaidIcon from "@mui/icons-material/Paid";
import { Dropdown } from "react-bootstrap";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import AreaChart from "../../../charts/AreaChart.js";
import GroupedBarChart from "../../../charts/GroupedBarChart.js";
import { Spinner } from "react-bootstrap";
import {
  CircularProgress,
} from "@mui/material";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let iconColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    iconColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    iconColor = "var(--maincolor-cmc)";
    break;
  default:
    iconColor = "var(--maincolor)";
    break;
}

const Income = ({ suitableArray, dashboardDataLoading }) => {
  const [monthBasedIncome, setMonthBasedIncome] = useState(undefined);
  const [selectedIncome, setSelectedIncome] = useState(null);
  const [chartType1Data, setChartType1Data] = useState([]);

  useEffect(() => {
    fetchSuitableIncome();
  }, [suitableArray]);

  useEffect(() => {
    filterTotalAmount(selectedIncome);
  }, [selectedIncome]);

  const filterTotalAmount = (selectedIncome) => {
    const suitableArray1 = suitableArray?.find(
      (item) =>
        item.chart_type === "ChargeableFees-info1" && item.chart_id === 2300
    );
    if (suitableArray1) {
      const groupedData = suitableArray1?.array.reduce((acc, obj) => {
        const key = `${obj.flg_chart_legend_x_filter}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
      if (groupedData) {
        const filteredGroupedData = Object.values(groupedData);
        const selectedTotalAmount = filteredGroupedData.find(
          (item) =>
            selectedIncome[0]?.flg_chart_legend_x_filter ===
            item[0].flg_chart_legend_x_filter
        );
        setChartType1Data(selectedTotalAmount);
      }
    }
  };

  const fetchSuitableIncome = () => {
    const suitableArray2 = suitableArray?.find(
      (item) =>
        item.chart_type === "ChargeableFees-info2" && item.chart_id === 2300
    );
    if (suitableArray2) {
      const groupedData = suitableArray2.array.reduce((acc, obj) => {
        const key = `${obj.flg_chart_legend_x_filter}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
      if (groupedData) {
        const filteredGroupedData = Object.values(groupedData);
        setMonthBasedIncome(filteredGroupedData);
        setSelectedIncome(filteredGroupedData[0]);
      }
    }
  };

  const renderStatsCharts = () => {
    const renderOuterComponent = (Component, val_) => {
      return <div className="row d-flex justify-content-around chart-container w-100" style={{ marginBottom: '20px' }}>
        <div className="col-lg-12 col-md-12 d-flex justify-content-center pb-md-3 pb-sm-3">
          <Component val={val_} />
        </div>
      </div>
    }
    const constructedArray = suitableArray.map((val, index) => {
      let applyValues = val.array
      if (val.chart_type == "Monthly-Revenue") {
        return renderOuterComponent(AreaChart, applyValues)
      }

    })
    return constructedArray
  }

  return (
    <div className="row d-flex">

      <div className="col-md-12 mb-3 pl-0 px-0 px-sm-0">
        {dashboardDataLoading ? (
          <div className="d-flex justify-content-center my-3 py-3">
            <CircularProgress />
          </div>
        ) : (
          <div className="dashboard__container">
            <div className="row d-flex justify-content-between align-items-center my-3">
              <h3 className="dashboard__container-title m-0">
                <SavingsRoundedIcon sx={{ fontSize: 22, color: "#5c5c5c" }} />{" "}
                Chargeable Fees
              </h3>
              <div className="">
                <div className="position-relative" style={{ minWidth: "150px" }}>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        border: "1px solid #E4E6EF",
                        color: "var(--secondary-text-color)",
                        fontWeight: "400",
                        fontSize: "10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {selectedIncome && selectedIncome[0]?.flg_chart_legend_x_filter}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: "100%", maxWidth: "none" }}>
                      {monthBasedIncome && monthBasedIncome.map((obj) => (
                        <Dropdown.Item
                          key={obj[0].flg_chart_legend_x_filter}
                          onClick={() => {
                            setSelectedIncome(obj);
                          }}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {obj[0].flg_chart_legend_x_filter}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="row d-flex dashboard__count-cards-orange align-items-center py-3">
              <div className="col-md-2 col-2 p-0 revenue__icon d-flex align-items-center">
                <SavingsRoundedIcon
                  sx={{
                    fontSize: 15,
                    color: "#fff",
                  }}
                />
              </div>
              {chartType1Data?.map((obj) => (
                <div className="col-md-10 col-10">
                  <p className="revenue-text">{obj.chart_x_value}</p>
                  <h3 className="revenue-amount m-0">{obj.chart_y_value}</h3>
                </div>
              ))}
            </div>
            <div className="row my-5">
              <div className="col-md-12 px-0">
                {selectedIncome?.map((obj) => (
                  <div className="row d-flex justify-content-between receivables-row">
                    <h5 className="receivables-title m-0">{obj.chart_x_value}</h5>
                    <p className="receivables-amount">{obj.chart_y_value}</p>
                  </div>
                ))}

              </div>
            </div>
          </div>
        )}
        {/* <h3 className="dashboard-subheading m-0 mt-8 pt-5">
                Monthly Revenue
              </h3> */}
        <div className="row">
          {renderStatsCharts()}
        </div>
      </div>

    </div>
  );
};

export default Income;
